import merge from "lodash/merge";
import * as ActionTypes from "../../actions";

// Updates an entity cache in response to any action with response.entities.
var userStatsEntities = function userStatsEntities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    byUserId: {}
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ActionTypes.LOGIN_SUCCESS:
    case ActionTypes.GET_AUTHENTICATION_SUCCESS:
      if (!action.response.userStatsByUserId) return state;
      var byUserId = action.response.userStatsByUserId;
      return merge({}, state, {
        byUserId: byUserId
      });
    case ActionTypes.GET_USERVIEWBYFOLLOWEEUSERNAMEANDAUTHUSERID_SUCCESS:
    case ActionTypes.GET_USERSVIEWBYAUTHUSERID_SUCCESS:
      if (!action.response.userStatsByUserId) return state;
      var byUserId = action.response.userStatsByUserId;
      return merge({}, state, {
        byUserId: byUserId
      });
    default:
      return state;
  }
};
export default userStatsEntities;